module.exports = __webpack_public_path__ + "static/amazonLogo-cf402e9640a6936ab9ca3e6195172cff.png";